export default {
  large: '@media (min-width: 768px)',
  small: '@media (max-width: 375px)',
};



// WEBPACK FOOTER //
// ./theme/media.js